module.exports = __webpack_public_path__ + "img/zyjy_06.bac137f4.png";